import PageTitle from '../components/PageTitle'
import ContentItem from '../components/ContentItem'
import contentsData from '../data/contentsData.json'
import SEO from '../components/SEO'

export default function Content() {
  return (
    <main className="bg-white">
      <SEO 
        title="콘텐츠"
        description="씨피엔터테인먼트가 제작하는 다양한 콘텐츠를 소개합니다. 자매치킨, 자매다방, SNL 코리아, 직장인들 등 쿠팡플레이 인기 예능 프로그램을 만나보세요."
        path="/content"
        keywords="cpent 콘텐츠, 씨피엔터테인먼트 제작, 자매치킨, 자매다방, SNL 코리아, 직장인들, 쿠팡플레이 예능, 쿠팡플레이 오리지널, cpentertainment content, SNL Korea"
        image="/images/contents/chicken-sisters.png"
      />
      {/* Page Title */}
      <PageTitle title="Content" />
      
      {/* Content Items */}
      <section className="content-items-wrapper">
        {contentsData.map((content) => (
          <ContentItem key={content.id} content={content} />
        ))}
      </section>
    </main>
  )
}
